export const size = {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    laptopS: '1024px',
    laptop:  '1280px',
    laptopL: '1440px',
    desktop: '2560px'
}
export const breakpoints = {
    mobileS: `(min-width: ${size.mobileS})`,
    mobileM: `(min-width: ${size.mobileM})`,
    mobileL: `(min-width: ${size.mobileL})`,
    tablet: `(min-width: ${size.tablet})`,
    laptopS: `(min-width: ${size.laptopS})`,
    laptop: `(min-width: ${size.laptop})`,
    laptopL: `(min-width: ${size.laptopL})`,
    desktop: `(min-width: ${size.desktop})`,    
    desktopL: `(min-width: ${size.desktop})`
}
export const baseColors = {
    wfaaRed: '#c5050c',
    wfaaRedInvert: '#fff',
    wfaaGray: '#707070',
    lighterGray: '#f2f2f2',
    mediumGray: '#a5a5a5',
    white: '#FFFFFF',
}
export const colors = {
    primary: baseColors.wfaaRed,
    primaryInvert: baseColors.wfaaRedInvert,
    secondary: baseColors.wfaaGray,
}
export const mixins = {
    a: `
    color: #c5050c;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    `,
    joblisting: `
    margin-top: 2.666em;
    border-top: 1px solid #CCCCCC;
    position: relative;
    &:first-of-type {
        border-top: none;
    }
    
    a {
        text-decoration: none;
        color: ${colors.primary};
      }
    h3 {
        font-weight: normal;
        font-size: 1.25em !important;
        max-width: calc(100% - 2.1em);
  
        margin: 2em 0 0.6em;
        padding: 0 !important;
        &:after {
            display: none;
        }
    }
    &__division {
        margin-bottom: 2em;
    }
    &__description {
        display: none;
        margin-bottom: 2.666em;
        p {
            font-size: 1em !important;
        }
    }
    &__link {
        display: none;
        text-transform: uppercase;
        position: relative;
        &:after {
            position: absolute;
            bottom: 0.1em;
            right: -1em;
            content: '>';
        }
    }
    
    .toggler {
      width: 2em;
      height: 2em;
        padding: .4em;
        position: absolute;
        right: 0;
          top: 2em;
        div {
          position: relative;
          background: #c5050c;
          height: 18px;
          width: 2px;
          margin: 0.5em auto;
          &:after {
            background: #c5050c;
            content: "";
            height: 2px;
            left: -8px;
            position: absolute;
            top: 8px;
            width: 18px;
          }
        }
        &:focus {
          outline: none;
        }
        
  
    }
    &.active {
        .job-listing__description {
            display: block;
            max-width: calc(100% - 1em);
        }
        .job-listing__link {
            display: inline-block;
        }
        .toggler {
          div {
            transform: rotate(45deg);
          }
        }
    }
    `
}